module.exports = __webpack_public_path__ + "img/12.375e0891.jpg";